import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function WhatsAppButton() {
  const whatsappNumber = '+919104465440';
  
  return (
    <a 
      href={`https://wa.me/${whatsappNumber}`}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      >
      <WhatsAppIcon />
      <span className="whatsapp-text">Join our group</span>
    </a>
  );
};